export default function(routes, pathname) {
  const cleanPathname = pathname.split('/')[1];
  return routes.some(route => route.split('/')[1] === cleanPathname);
};
